<template>
  <div>  
    <h3 class="main-title">
      <b>
        {{ $t("main-title1") }}
        <br />
        {{ $t("main-title2") }}
      </b>
    </h3>

    <b-container class="pia-content px-5">
      <div class="mt-5">{{ $t("paragraph1") }}</div>

      <!--title1-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title1") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>1.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title1-paragraph1") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>1.2</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title1-paragraph2") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>1.3</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title1-paragraph3") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>1.4</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title1-paragraph4") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>1.5</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title1-paragraph5") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>1.6</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title1-paragraph6") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>1.7</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title1-paragraph7") }}
        </div>
      </div>

      <!--title2-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title2") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>2.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title2-paragraph1") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>2.2</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title2-paragraph2") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>2.3</div>
        <div class="ml-2 paragraph">
          <a>{{ $t("sub-title2-paragraph3-1") }}</a>
          <span class="bd-blue" style="cursor:pointer">
            https://www.iamsmart.gov.hk
          </span>
          {{ $t("sub-title2-paragraph3-2") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>2.4</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title2-paragraph4") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>2.5</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title2-paragraph5") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>2.6</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title2-paragraph6") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>2.7</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title2-paragraph7-1") }}
          <span class="bd-blue" style="cursor:pointer">
            esh-helpdesk@bd.gov.hk
          </span>
          <span v-if="$i18n.locale=='en'">.</span>
          <span v-if="$i18n.locale!='en'">{{ $t("sub-title2-paragraph7-2") }}</span>
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>2.8</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title2-paragraph8") }}
        </div>
      </div>

      <!--title3-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title3") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>3.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title3-paragraph1") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(a)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title3-paragraph1-a-1") }}
          <b>{{ $t("sub-title3-paragraph1-a-2") }}</b>
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(b)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title3-paragraph1-b") }}
        </div>
      </div>

      <div class="mt-4 sub-title" style="margin-left: 5rem">
        <div>(i)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title3-paragraph1-b-i") }}
        </div>
      </div>

      <div class="mt-4 sub-title" style="margin-left: 5rem">
        <div>(ii)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title3-paragraph1-b-ii") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(c)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title3-paragraph1-c-1") }}
          <b>{{ $t("sub-title3-paragraph1-c-2") }}</b>
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(d)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title3-paragraph1-d") }}
        </div>
      </div>

      <!--title4-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title4") }}</b>
      </h4> 

      <div class="mt-4 ml-4 sub-title">
        <div>4.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title4-paragraph1") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>4.2</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title4-paragraph2") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>4.3</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title4-paragraph3") }}
        </div>
      </div>

      <!--title5-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title5") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>5.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph1") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(a)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph1-a") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(b)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph1-b") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(c)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph1-c") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(d)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph1-d") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(e)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph1-e") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>5.2</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph2") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>5.3</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph3") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(a)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph3-a") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(b)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph3-b") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>5.4</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph4") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(a)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph4-a") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(b)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title5-paragraph4-b") }}
        </div>
      </div>

      <!--title6-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title6") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>6.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title6-paragraph1") }}
        </div>
      </div>

      <!--title7-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title7") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>7.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph1") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>7.2</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph2") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>7.3</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph3") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>7.4</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph4") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>7.5</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph5") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(a)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph5-a") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(b)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph5-b") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>7.6</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph6") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>7.7</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title7-paragraph7") }}
        </div>
      </div>

      <!--title8-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title8") }}</b>
      </h4>
      
      <div class="mt-4 ml-4 sub-title">
        <div>8.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title8-paragraph1") }}
        </div>
      </div>

      <!--title9-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title9") }}</b>
      </h4>
      
      <div class="mt-4 ml-4 sub-title">
        <div>9.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph1") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.2</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph2") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.3</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph3") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.4</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph4") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.5</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph5") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(a)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph5-a") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(b)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph5-b") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(c)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph5-c") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(d)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph5-d") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(e)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph5-e") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(f)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph5-f") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(g)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph5-g") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.6</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph6") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.7</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph7") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.8</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph8") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.9</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph9") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>9.10</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title9-paragraph10") }}
        </div>
      </div>

      <!--title10-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title10") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>10.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph1") }}
        </div>
      </div>

      <div class="mt-4 ml-4 sub-title">
        <div>10.2</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(a)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2-a") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(b)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2-b") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(c)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2-c") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(d)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2-d") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(e)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2-e") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(f)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2-f") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(g)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2-g") }}
        </div>
      </div>

      <div class="mt-4 ml-5 sub-title">
        <div>(h)</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title10-paragraph2-h") }}
        </div>
      </div>

      <!--title11-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title11") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>11.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title11-paragraph1") }}
        </div>
      </div>

      <!--title12-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title12") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>12.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title12-paragraph1") }}
        </div>
      </div>

      <!--title13-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title13") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>13.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title13-paragraph1") }}
        </div>
      </div>

      <!--title14-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title14") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>14.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title14-paragraph1") }}
          <span class="bd-blue" style="cursor:pointer">
            esh-helpdesk@bd.gov.hk
          </span>
          {{ $t("sub-title14-paragraph2") }}
        </div>
      </div>

      <!--title15-->
      <h4 class="mt-5">
        <b>{{ $t("sub-title15") }}</b>
      </h4>

      <div class="mt-4 ml-4 sub-title">
        <div>15.1</div>
        <div class="ml-2 paragraph">
          {{ $t("sub-title15-paragraph1") }}
        </div>
      </div>
      <br />
      <div class="float-right title-ref pb-5">{{$t('last-revision-date')}}</div>
    </b-container>
  </div>
</template>

<script>
export default {
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    },
  }
};
</script>

<style lang="scss" scoped>
.main-title {
  display: flex;
  justify-content: center;
  text-align: center;
}
.bd-blue {
 text-decoration: underline;
}
.bd-blue:hover {
 color: #CC4400;
}
.sub-title {
  display: flex;
}
.paragraph {
  width: 100%;
  margin-right: 2rem;
}
.title-ref {
  margin-right: 2rem;
}
</style>

<script>


export default {
  methods: {
    redirectLogin() {
      this.$router.push({ name: 'Login' });
    },
  }
};
</script>


<i18n src="@/locales/actions.locale"></i18n>

<i18n src="@/public/locales/modules/pia/components/TermsAndConditions.json" />